import { useSyncExternalStore, useMemo } from 'react';

const listeners = new Set<() => void>();

function notify() {
  listeners.forEach((listener) => listener());
}

function subscribe(callback: () => void) {
  listeners.add(callback);
  if (listeners.size === 1) {
    window.addEventListener('resize', notify);
  }
  return () => {
    listeners.delete(callback);
    if (listeners.size === 0) {
      window.removeEventListener('resize', notify);
    }
  };
}

const getWidthSnapshot = () => (typeof window !== 'undefined' ? window.innerWidth : 0);
const getHeightSnapshot = () => (typeof window !== 'undefined' ? window.innerHeight : 0);
const getServerSnapshot = () => 0;

export function useWindowWidth() {
  return useSyncExternalStore(subscribe, getWidthSnapshot, getServerSnapshot);
}

export function useWindowHeight() {
  return useSyncExternalStore(subscribe, getHeightSnapshot, getServerSnapshot);
}

/**
 * 如果如果只需要监听宽高其中一个值，建议使用 `useWindowWidth` 或 `useWindowHeight`
 * @returns
 */
export function useWindowSize() {
  const width = useWindowWidth();
  const height = useWindowHeight();
  return useMemo(() => ({ width, height }), [width, height]);
}
